export default {
  status: {
    rejected: {
      title: "Order rejected",
    },
    created: {
      title: "Order received",
    },
    reviewed: {
      title: "Your order has been seen",
    },
    confirmed: {
      title: "Order confirmed",
    },
    waiting_confirmation: {
      title: "Awaiting order confirmation",
      description: "Hold tight...",
    },
    pickup_time: {
      title: "Pickup time",
      description: "Confirmed from {{name}}",
    },
    delivery_time: {
      title: "Delivery time",
      description: "Confirmed from {{name}}",
    },
  },
};
